<div class="wrapper">
  <div class="action-section flex flex-row-reverse my-[20px] w-full gap-[20px]">
    <!-- Default toolbar -->
    @if (!isSearchFocused) {
      <app-primary-button (click)="create()" class="!w-[150px]">Create</app-primary-button>
      <app-secondary-button (click)="upload()" class="!w-[150px]">Upload</app-secondary-button>
      <div class="submittals-filters flex flex-row gap-[20px] flex-1 mt-[7px]">
        <div>
          @if (selectedSortColumn) {
            <mat-form-field class="sort-dropdown">
              <mat-select
                (selectionChange)="onSortColumnChange($event)"
                [(value)]="selectedSortColumn"
                disableOptionCentering
                panelClass="submittals-registry-sort-panel"
                >
                <mat-select-trigger>
                  {{ selectedSortColumn ? 'Sort by: ' + selectedSortColumn : 'Sort: ' }}
                </mat-select-trigger>
                @for (column of sortByColumns; track column) {
                  <mat-option [value]="column">
                    {{ column | titlecase }}
                  </mat-option>
                }
              </mat-select>
              <mat-icon (click)="removeSort($event)" class="sort-close" matSuffix> close </mat-icon>
            </mat-form-field>
          }
          @if (!selectedSortColumn) {
            <div class="sort-dropdown nosort" (click)="openSortDropdown($event)">
              <div class="label text-type-8">Sort:</div>
              <mat-icon>sync_alt</mat-icon>
              <!-- Hidden select used only to open the same dropdown without changing layout -->
              <mat-form-field class="sr-sort-hidden">
                <mat-select
                  #sortSelect
                  (selectionChange)="onSortColumnChange($event)"
                  [(value)]="selectedSortColumn"
                  disableOptionCentering
                  panelClass="submittals-registry-sort-panel"
                  >
                  @for (column of sortByColumns; track column) {
                    <mat-option [value]="column">
                      {{ column | titlecase }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
        </div>
        <div class="search-section flex flex-1 flex-row gap-[10px] min-w-0">
          <form [formGroup]="form" class="flex-1 min-w-0">
            <div class="search w-full">
              <mat-icon (click)="search()" svgIcon="search"></mat-icon>
              <input
                (focus)="onSearchFocus()"
                class="search-input"
                formControlName="searchText"
                matInput
                placeholder="Search"
                />
              @if (form.controls.searchText.value) {
                <mat-icon (click)="close()" svgIcon="close"></mat-icon>
              }
            </div>
          </form>
        </div>
      </div>
    } @else {
      <form [formGroup]="form" class="flex-1 min-w-0">
        <div class="search w-full">
          <mat-icon (click)="search()" svgIcon="search"></mat-icon>
          <input
            #searchInput
            (focus)="onSearchFocus()"
            class="search-input"
            formControlName="searchText"
            matInput
            placeholder="Search"
            />
          <mat-icon (click)="close()" svgIcon="close"></mat-icon>
        </div>
      </form>
    }
    <!-- Full-width search bar -->
  </div>
</div>
<div class="list-section">
  <div class="resource-table flex flex-col gap-[40px]">
    @if (dataSource?.length) {
      <div class="bit-items-table">
        <table [dataSource]="dataSource" class="mat-elevation-z8 table" mat-table>
          <!-- Section # -->
          <ng-container matColumnDef="sectionNo">
            <th *matHeaderCellDef mat-header-cell [class.ellipsis-header]="selectedSortColumn === 'Section no'">
              <span class="th-text">Section #</span>
              @if (selectedSortColumn === 'Section no') {
                <span>
                  <mat-icon (click)="toggleSortDirection()" class="sort-column">
                    {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                  </mat-icon>
                </span>
              }
            </th>
            <td *matCellDef="let row" mat-cell>
              <div class="text-type-11">{{ row?.section_no }}</div>
            </td>
          </ng-container>
          <!-- Sub Section # -->
          <ng-container matColumnDef="subSectionNo">
            <th *matHeaderCellDef mat-header-cell [class.ellipsis-header]="selectedSortColumn === 'Sub section no'">
              <span class="th-text">Sub section #</span>
              @if (selectedSortColumn === 'Sub section no') {
                <span>
                  <mat-icon (click)="toggleSortDirection()" class="sort-column">
                    {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                  </mat-icon>
                </span>
              }
            </th>
            <td *matCellDef="let row" mat-cell>
              <div class="text-type-11">{{ row?.sub_section_no }}</div>
            </td>
          </ng-container>
          <!-- ✅ Created By (before Title) -->
          <ng-container matColumnDef="createdBy">
            <th *matHeaderCellDef mat-header-cell [class.ellipsis-header]="selectedSortColumn === 'Created by'">
              <span class="th-text">Created by</span>
              @if (selectedSortColumn === 'Created by') {
                <span>
                  <mat-icon (click)="toggleSortDirection()" class="sort-column">
                    {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                  </mat-icon>
                </span>
              }
            </th>
            <td *matCellDef="let row" mat-cell>
              <div class="text-type-11">{{ row?.createdBy?.first_name }} {{ row?.createdBy?.last_name }}</div>
            </td>
          </ng-container>
          <!-- Title -->
          <ng-container matColumnDef="title">
            <th *matHeaderCellDef mat-header-cell [class.ellipsis-header]="selectedSortColumn === 'Title'">
              <span class="th-text">Title</span>
              @if (selectedSortColumn === 'Title') {
                <span>
                  <mat-icon (click)="toggleSortDirection()" class="sort-column">
                    {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                  </mat-icon>
                </span>
              }
            </th>
            <td *matCellDef="let row" mat-cell>
              <div class="text-type-11">{{ row?.title }}</div>
              <div class="description text-type-14">{{ row?.description }}</div>
            </td>
          </ng-container>
          <!-- Header & Row Definitions -->
          <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
          <tr
            (click)="rowClicked(row)"
            *matRowDef="let row; columns: displayedColumns"
            [class.highlighted-row]="row === selectedRow"
            mat-row
          ></tr>
        </table>
      </div>
    }
    @if (!dataSource?.length) {
      <div class="no-data text-type-11 mt-[80px]">No data available.</div>
    }
    <app-paginator
      (pageChanged)="onPageChanged($event)"
      [itemsPerPage]="pagination?.pageSize"
      [maxVisiblePages]="5"
      [totalItems]="totalRecords"
      class="paginator"
      />
  </div>
</div>
<input #csvFileUploadRef (change)="handleCsvFileUpload()" [id]="'fileUploadRef'" class="hidden" type="file" />
